import styled, { css } from 'styled-components';

export const FormContainerWrapper = styled.form<{ scrollable?: boolean; alignItems?: string }>`
  transition: all ease-in-out 0.15s;
  padding: 0 20px;
  height: 100%;
  ${({ scrollable }) =>
    scrollable &&
    css`
      overflow-y: scroll;
      overflow-x: hidden;
      width: 100%;
      display: grid;
      align-items: ${({ alignItems }) => alignItems || 'center'};
    `}
`;

export const FormContainerItems = styled.div<{ scrollable?: boolean }>`
  width: 100%;
  ${({ scrollable }) =>
    scrollable &&
    css`
      height: calc(100% - 100px);
      overflow-y: scroll;
      overflow-x: hidden;
      display: grid;
      align-items: center;
    `}
  @media (max-width: 1200px) {
    padding: 120px 0;
  }
`;

export const FormTitle = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.span<{ center: boolean }>`
  font-size: 20px;
  font-weight: 800;
  ${({ center }) =>
    center &&
    css`
      margin: 0 auto;
    `}
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Button = styled.button<{ wide?: boolean; autoResize?: boolean }>`
  width: ${({ wide, autoResize }) => (autoResize ? 'auto' : wide ? '200px' : '116px')};
  height: 45px;
  font-size: 16px;
  border-radius: 22.5px;
  background-color: var(--black);
  color: var(--white);
  border: none;
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
  user-select: none;
  padding: ${({ autoResize }) => (autoResize ? '0 40px' : '0')};
`;

export const PreviousButton = styled.button`
  width: 36px;
  min-width: 36px;
  max-width: 36px;
  min-height: 36px;
  max-height: 36px;
  height: 36px;
  border-radius: 50%;
  border: solid 2px var(--black);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 20px;
  &:hover {
    background-color: var(--black);
    svg {
      stroke: var(--white);
      fill: var(--white);
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}

  @media (max-width: 1200px) {
    top: 32px;
    left: 20px;
  }
`;

export const Submit = styled.div<{ buttonMargin?: string }>`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: ${({ buttonMargin }) => (buttonMargin ? buttonMargin : '28px 0')};
`;
export const Accessibility = styled.span`
  user-select: none;
  opacity: 0.6;
  font-size: 12px;
  span {
    font-weight: 800;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;
